import React, { createContext, useState, useContext, useEffect } from 'react';
import { api } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.me()
        .then(u => setUser(u))
        .catch(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }

  }, []);

  const login = async (username, password) => {
    const data = await api.login(username, password);
    localStorage.setItem('token', data.token);
    localStorage.setItem('sessionId', data.sessionId);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.logout();
    } catch (e) { /* ignore */ }
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('sessionId');
    setUser(null);
  };

  const isAdmin = user && (user.role === 'admin' || user.role === 'both');
  const isResponsable = user && user.role === 'responsable';

  // Check per-page visibility across all stores
  const canView = (page) => {
    if (isAdmin) return true;
    const field = `view_${page}`;
    return (user?.stores || []).some(s => s[field]);
  };

  const canViewStore = (page, storeId) => {
    if (isAdmin) return true;
    const field = `view_${page}`;
    return Boolean((user?.stores || []).find(s => s.id === Number(storeId))?.[field]);
  };

  const canManageStore = (perm, storeId) => {
    if (isAdmin) return true;
    if (!isResponsable) return false;
    return Boolean((user?.stores || []).find(s => s.id === Number(storeId))?.[perm]);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin, isResponsable, canView, canViewStore, canManageStore }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
